import { Customer, GiftCard, OrderReceipt } from 'olo-service';
import { useCallback } from 'react';
import { toCents } from 'util/Formatting';
import { isSlug } from './isSlug';
import { useColoRequest } from './useColoRequest';

type TableOrderPaymentsRequest = {
  tableUuid?: string;
  paymentToken?: string;
  tipValue?: number;
  customer?: Customer;
  captchaToken?: RecaptchaToken;
  appliedGiftCards?:GiftCard[]
}

export function useTableOrderPaymentsRequest(merchantId?: string, sessionId?: string) {

  const [, postTableOrderPayments] = useColoRequest(({ tableUuid, paymentToken, tipValue, customer, captchaToken,appliedGiftCards }: TableOrderPaymentsRequest) => merchantId && tableUuid && customer && ({
    method: 'POST',
    url: `${merchantId}/tables/${tableUuid}/order/payments`,
    headers: {
      'X-Clover-Customer-Auth': sessionId,
      'X-Captcha-Token': captchaToken
    },
    params: { slug: isSlug(merchantId) },
    data: { paymentToken, customer, tipAmount: toCents(tipValue || 0), ...(!!appliedGiftCards?.length && { giftSources: appliedGiftCards }) },
  }), [merchantId]);

  return useCallback(async (request: TableOrderPaymentsRequest) => {
    const response = await postTableOrderPayments<OrderReceipt>(request);

    if (!response) throw new Error('PostOrders returned an empty response');

    return response;
  }, [postTableOrderPayments]);
}
